import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import useAppState from "context/useAppState";

interface props {
  height?: string;
  width?: string;
}

const RadialBar = ({ height, width }:props) => {
  const [daysRemaining, setDaysRemaining] = useState(0);

  const {
    setState,
    downloadChart,
    downloadChartName,
    chartName
  } = useAppState("eventData");

  const chartRef = React.useRef<any>(null);

  useEffect(() => {
    if (downloadChart) {
      downloadAsSVG()
      setState({ downloadChart: false })
    }
  }, [downloadChart])

  const downloadAsSVG = async () => {
    if (chartRef.current && chartName == 'radial_bar') {
      try {
        await chartRef.current.chart.exports.exportToSVG(); // Use getSVGString for SVG data
      } catch (error) {
        console.error("Error downloading chart:", error);
      }
    }
  };

  // Calculate days remaining until the event ends (May 5, 2024)
  useEffect(() => {
    const eventEndDate = new Date("2024-07-05");
    const currentDate = new Date();
    const timeDifference = eventEndDate.getTime() - currentDate.getTime();
    const daysRemaining = Math.ceil(timeDifference / (1000 * 60 * 60 * 24)); // Calculate days remaining
    setDaysRemaining(daysRemaining);
  }, []);

  const chartOptions: ApexOptions = {
    chart: {
      type: "radialBar",
      toolbar: {
        show: false,
        export: {
          svg: {
            filename: downloadChartName
          }
        }
      },
    },
    plotOptions: {
      radialBar: {
        track: {
          background: "#EAECF0", // color for track
        },
        hollow: {
          size: "65%", // Set the size of the inner circle (0-100%)
        },
        dataLabels: {
          name: {
            offsetY: -10,
          },
          value: {
            offsetY: 10,
            show: true,
            formatter: (val: number) => {
              return val.toString(); // Customize the format of the data value (e.g., remove '%' symbol)
            },
          },
        },
      },
    },
    states: {
      hover: {
        filter: {
          type: "none",
        },
      },
    },
    colors: ["#1E0AF5"], // Set the color of the radial bar
    stroke: {
      lineCap: "round",
    },
    labels: ["Days to go"],
    series: [52], // Set the value for the radial bar (percentage)
  };

  return (
    <div>
      <ReactApexChart
        ref={chartRef}
        options={chartOptions}
        series={chartOptions.series}
        type='radialBar'
        height={height || 220}
        width={width || 210}
      />
    </div>
  );
};

export default RadialBar;
